// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"120":"Contacts","308":"Video","596":"PixelArt","653":"Design","685":"Motion","692":"Dev","810":"NotFound"}[chunkId] + "." + {"120":"8b980cdf","308":"8f729aaf","596":"7b8961af","653":"a45d0fde","685":"8f433d58","692":"919424f4","810":"87b6df14"}[chunkId] + ".chunk.css";
};